/**
 * axios拦截器
 */
import axios from "axios";
import router from "@/router";
import { Toast } from "vant";
import store from "@/store";
import { getEnv } from "@/config/utils";
import { localDB } from "@/config/storage";
import { routerPush } from "@/config/locationRouter";
import { getWxOpenCode } from "@/config/login";
import { getCorpCode } from "@/config/yqy";

const request = axios.create({
  baseURL: process.env.VUE_APP_YQY_API_BASE_URL,
  timeout: 25000
});

request.interceptors.request.use(
  config => {
    const TOKEN = localDB.getItem("TOKEN");
    const corpCode = getCorpCode();
    if (config.auth) {
      config.headers.token = TOKEN;
    }
    if (corpCode) {
      config.headers.corpCode = corpCode;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code === "1000") {
        localDB.removeItem("TOKEN");
        store.commit("user/SET_TOKEN", undefined);
        if (getEnv() !== "h5") {
          //判断所处环境
          console.log("没授权");
          getWxOpenCode(router.currentRoute.fullPath);
        } else {
          routerPush({
            path: "/login",
            query: {
              target: router.currentRoute.fullPath
            }
          });
        }
      }
      else {
        return response.data;
      }
    }
  },
  error => {
    try {
      const status = error.response.status;
      if (status === 401 || status === 402) {
        localDB.removeItem("TOKEN");
        store.commit("user/SET_TOKEN", undefined);
        if (getEnv() !== "h5") {
          //判断所处环境
          console.log("没授权");
          getWxOpenCode(router.currentRoute.fullPath);
        } else {
          routerPush({
            path: "/login",
            query: {
              target: router.currentRoute.fullPath
            }
          });
        }
        // 张帆风顺是个傻逼
      } else if (status === 500) {
        Toast.fail("后台异常，请稍后再试！");
        // routerReplace({
        //   path: "/errorWork",
        //   query: {
        //     fullPath: router.currentRoute.fullPath
        //   }
        // });
      } else if (status === 404) {
        Toast.fail("404 notFound");
        // routerReplace({ path: "/notFound" });
      }
    } catch (err) {
      // if (error.toString().includes("timeout")) {
      //   routerReplace({
      //     path: "/errorWork",
      //     query: {
      //       fullPath: router.currentRoute.fullPath
      //     }
      //   });
      // } else {
      //   /* 统一做无网络处理 */
      //   routerReplace({
      //     path: "/errorHelp",
      //     query: {
      //       fullPath: router.currentRoute.fullPath
      //     }
      //   });
      // }
    }
  }
);

export default request;
